import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { CompaniesComponent } from "../../components/companies"
import { DefaultPageComp } from "../../components/defaultPage"

export const CompaniesPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <CompaniesComponent />
    </DefaultPageComp>
  </>
}